import AbstractConfig from "../core/config/AbstractConfig";

export default class GoogleAnalyticsConfig extends AbstractConfig {
    constructor(){
        super();
    }

    /** @return {string} Tracking ID for the Google Analytics Property */
    get trackingId() {
        return this.getValue("trackingId");
    }

    /** @return {boolean} True if Analytics is enabled; False, otherwise */
    get isEnabled() {
        return this.getValue("enabled");
    }

    /** @return {boolean} True if IP tracking is anonymous; False, otherwise */
    get isAnonymousIp() {
        return this.getValue("anonymousIp");
    }
}